import { IProductionReducerInitialState } from "./ProductionReducer.types";
// TODO - lawrence -  create new transform for label + id dynamically populate table data
const productionReducerInitialState: IProductionReducerInitialState = {
  commissionInputValues: [
    {
      placeholder: "Risk-Protection Production",
      value: "",
      inputId: "commission-risk-protection",
    },
    {
      placeholder: "Other New Business",
      value: "",
      inputId: "commission-other-new-business",
    },
  ],
  commissionCheckboxValue: false,
  commissionProduction: [],
  premiumInputValues: [
    {
      placeholder: "Risk-Protection Production",
      value: "",
      inputId: "premium-risk-protection",
    },
    {
      placeholder: "Other New Business",
      value: "",
      inputId: "premium-other-new-business",
    },
  ],
  premiumCheckboxValue: false,
  premiumProduction: [],
  incomeInputValues: [
    {
      placeholder: "Risk-Protection Production",
      value: "",
      inputId: "income-risk-protection",
    },
    {
      placeholder: "Other New Business",
      value: "",
      inputId: "income-other-new-business",
    },
    {
      placeholder: "Total Income Reported",
      value: "",
      inputId: "total-income",
    },
  ],
  incomeCheckboxValue: false,
  incomeProduction: [],
  commissionPoliciesCasesInputValues: [
    {
      placeholder: "Risk-Protection Policies / Cases",
      value: "",
      inputId: "commission-risk-protection",
    },
    {
      placeholder: "Other Policies / Cases",
      value: "",
      inputId: "commission-other-new-business",
    },
  ],
  commissionPoliciesCasesCheckboxValue: false,
  commissionPoliciesCases: [],
  premiumPoliciesCasesInputValues: [
    {
      placeholder: "Risk-Protection Policies / Cases",
      value: "",
      inputId: "premium-risk-protection",
    },
    {
      placeholder: "Other Policies / Cases",
      value: "",
      inputId: "premium-other-new-business",
    },
  ],
  premiumPoliciesCasesCheckboxValue: false,
  premiumPoliciesCases: [],
  incomePoliciesCasesInputValues: [
    {
      placeholder: "Risk-Protection Policies / Cases",
      value: "",
      inputId: "income-risk-protection",
    },
    {
      placeholder: "New Business Policies / Cases",
      value: "",
      inputId: "income-other-new-business",
    },
  ],
  incomePoliciesCasesCheckboxValue: false,
  incomePoliciesCases: [],
  currency: new Map([
    ["USD", "$"],
    ["EURO", "€"],
    ["FRANC", "₣"],
    ["YEN", "¥"],
  ]),
  selectedCurrency: "USD",
};

export default productionReducerInitialState;
